<template>
    <section class="main dashboard">
        <router-link v-if="getUser.user_type_code != 'EMPLOYEE'" to="/navigator"><h2 class="back-link" style="margin: 0.33em 0 0 1em;">Navigator Home <i class="fas fa-chevron-right"></i></h2></router-link>
        <h1 class="dashboard">Promotion Packs</h1>
        <div class="two-columns">
            <div class="tiles">
                <div class="tile" style="margin: 0 0 2em 0;">
                    <div class="title promotions">Promotion Packs</div>
                    <div class="stat">{{ formatNumber(totals.promo_packs) }}</div>
                    <div class="caption">All promo packs</div>
                    <div class="stat">{{ formatNumber(totals.emails_sent) }}</div>
                    <div class="caption">Emails Sent <label>(last 30 days)</label></div>
                    <router-link to="/promotionpacks" tag="a" class="link promotions"><span class="icon">&#x27A4;</span> Manage Promotion Packs</router-link>
                </div>
                <div class="tile">
                    <div class="title marquees">Campaign Reports</div>
                    <div class="stat">{{ formatNumber(totals.active_accounts) }}</div>
                    <div class="caption">Active dealer lists</div>
                    <div class="stat">{{ formatNumber(totals.email_addresses) }}</div>
                    <div class="caption">Email addresses</div>
                    <router-link to="/campaignreports" tag="a" class="link marquees"><span class="icon">&#x27A4;</span> View Campaign Reports</router-link>
                </div>
            </div>
            <div class="recent-campaign" v-if="email && email.totals">
                <h2>Most Recent Campaign</h2>
                <div class="two-columns">
                    <div class="recent-campaign-preview">
                        <img :src="email.image_src" style="width: 100%;">
                        <h3 style="font-size: 2em; margin: 0.5em 0;">{{ email.title }}</h3>
                        <h4>{{ email.subhead }}</h4>
                        <div v-html="email.content"></div>
                    </div>
                    <div class="two-columns">
                        <label>Send Date</label>
                        <h3>{{ email.schedule_date }}</h3>
                        <label>Emails Sent</label>
                        <h3>{{ formatNumber(email.totals.sent) }}</h3>
                        <label>Total Opens</label>
                        <h3>{{ formatNumber(email.totals.opened) }}</h3>
                        <label>Total Clicks</label>
                        <h3>{{ formatNumber(email.totals.clicked) }}</h3>
                        <label>Open Rate</label>
                        <h3>{{ email.totals.open_rate }}%</h3>
                        <label>Click Rate</label>
                        <h3>{{ email.totals.click_rate }}%</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            loading: true,
            message: 'Loading',
            totals: {},
            email: {}
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
		fetchData() {
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_promotion_dashboard_stats' }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.message = ''
                    this.totals = obj.totals
                    this.email = obj.email
                } else {
                    this.message = obj.message
                }
            })
        },
        setReportYear() {
            this.updateReportYear(this.reportYear)
            this.totals = {}
            this.fetchData()
        }
    }
}
</script>

<style lang="scss" scoped>
.recent-campaign {
    margin: 2em 0;
    .recent-campaign-preview {
        background-color: #f4f4f4;
        padding: 1em;
    }
}
</style>
